import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { Item } from '../../../core/components/listbox/listbox.component';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';

@Component({
  selector: 'tt-components',
  templateUrl: './components.component.html',
  styleUrls: ['./components.component.css']
})
export class ComponentsComponent implements OnInit {
    prodId;

    public setting?: Setting;

    public itemsListComponents: Item[] = [];

    public grid?: GridOptions;

    public productIdButtons: FormButton[] = [
        { id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'product', gotoParms: () => this.setting!.prod_id ?? '' }
    ];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.prodId = this.stateService.getStateParams()['prod_id'];
    }

    private async loadSetting() {
        if (!!this.prodId) {
            this.setting = (await this.datatask.Post(722, { prod_id: this.prodId }))[0];
        }
    }

    private async loadComponents() {
        if (!!this.setting) {
            this.itemsListComponents = await this.datatask.Post(706, {
                prod_id: this.setting.prod_id,
                gb_compfunction: this.setting.gb_compfunction
            });
        }
    }

    private loadGrid() {
        if (!!this.setting) {
            if (!this.grid) {
                this.grid = new Grid()
                    .setRememberId('w_components_grid')
                    .setLoadDataFunction({
                        method: 3743,
                        parameters: { prod_id: this.setting.prod_id }
                    })
                    .setKendoConfig({ height: '100%' })
                    .setToolbar({ wrapping: true })
                    .setCustomToolbarButtons([{
                        name: 'components_add',
                        text: 'components_add',
                        func: () => this.stateService?.go('component', {
                            prod_id: this.prodId,
                            comp_keyno: '0'
                        }),
                        icon: 'fas fa-plus',
                        cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
                        translate: true
                    }]);
            } else {
                this.grid?.gridfunc?.read();
            }
        }
    }

    public onTabChange() {
        this.loadComponents();
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'component':
                this.stateService?.go('component', {
                    prod_id: this.prodId,
                    comp_keyno: '0'
                });
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadComponents();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    prod_id: string;
    prod_name: string;
    gb_compfunction: string;
}
